module.exports = __webpack_public_path__ + "static/media/rappi.1d4fcedb.png";